import React, { memo } from 'react'
import * as Styled from './styled'
import CloseIcon from 'assets/svgr-icons/Close.svg'
import { IProps } from './types'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { dispatch } from 'store'
import ReferenceImageContent from './Image'
import Icon from 'common-components/Icon'
import { normalizeAspectRatio } from 'utils/aspectRatio'
import { convertSizeToAspectRatio } from 'store/features/projectData/utils'

const AiReferenceImagesItem: React.FC<IProps> = ({ item }) => {
  const { id, url, width, height } = item
  const aspectRatio = normalizeAspectRatio(
    convertSizeToAspectRatio(width, height)
  )
  const handleRemoveImage = (id: number) => {
    dispatch(aiImageThunks.removeReferenceImage(id))
  }

  return (
    <Styled.ReferenceImagesOuterContainer>
      <ReferenceImageContent id={id} url={url} aspectRatio={aspectRatio} />
      <Styled.RemoveImageIconWrapper onClick={() => handleRemoveImage(id)}>
        <Icon icon={<CloseIcon />} size="small" color="secondarySemiLight" />
      </Styled.RemoveImageIconWrapper>
    </Styled.ReferenceImagesOuterContainer>
  )
}

export default memo(AiReferenceImagesItem)
